export default __webpack_public_path__ + "/dist/images/image00011.11b9970246f84452f44fbb91f466f5f8.jpeg";